import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CreditCard, Shield, Clock, DollarSign, Banknote, Smartphone } from 'lucide-react';

const PaymentMethodsGuide = () => {
  return (
    <div className="min-h-screen bg-book-cream">
      <Header />
      <main className="book-section">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-book-brown mb-6">
              Payment Methods & Security
            </h1>
            <p className="text-xl text-book-brown-dark leading-relaxed">
              Navigate secure deposit and withdrawal options available to UK players with confidence and peace of mind.
            </p>
          </div>

          <div className="mb-16 bg-book-beige rounded-xl p-8 shadow-book-inset">
            <h2 className="text-2xl font-bold text-book-brown mb-6 text-center">Our Guide Writing Philosophy</h2>
            <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
              <p>Every guide published on Brit Ember represents extensive research and deep industry insights...</p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-6">Securing Your Financial Transactions</h2>
            <p>Payment processing represents the critical infrastructure that enables casino gaming...</p>
          </div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-8 text-center">Payment Method Analytics</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">UK Player Preferences</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark flex items-center">
                      <CreditCard className="h-4 w-4 mr-2" />
                      Debit Cards
                    </span>
                    <span className="font-semibold text-book-brown">45%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark flex items-center">
                      <Smartphone className="h-4 w-4 mr-2" />
                      PayPal
                    </span>
                    <span className="font-semibold text-book-brown">28%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark flex items-center">
                      <Banknote className="h-4 w-4 mr-2" />
                      Bank Transfer
                    </span>
                    <span className="font-semibold text-book-brown">15%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark flex items-center">
                      <DollarSign className="h-4 w-4 mr-2" />
                      Skrill/Neteller
                    </span>
                    <span className="font-semibold text-book-brown">12%</span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Processing Speed Comparison</h3>
                <div className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Instant E-wallets</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '100%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">&lt;1 min</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Credit Cards</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '95%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">&lt;5 min</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Bank Transfers</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-orange-500 h-3 rounded-full" style={{width: '60%'}}></div>
                      </div>
                      <span className="font-semibold text-orange-600">1-3 days</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Security Rating by Method</h3>
                <div className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Bank Transfers</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '100%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">A+</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">PayPal</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '95%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">A</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Credit Cards</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-yellow-500 h-3 rounded-full" style={{width: '85%'}}></div>
                      </div>
                      <span className="font-semibold text-yellow-600">B+</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
            <p>Payment processing represents the critical infrastructure that enables casino gaming...</p>
            <div className="bg-book-beige rounded-lg p-6 my-8">
              <h4 className="text-xl font-bold text-book-brown mb-4">Essential Payment Security Principles</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <Shield className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Always use licensed, regulated payment providers</span>
                </li>
                <li className="flex items-start">
                  <Clock className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Understand processing times and fees before transactions</span>
                </li>
                <li className="flex items-start">
                  <DollarSign className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Monitor accounts regularly for unauthorized activity</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentMethodsGuide;
